/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupStrawIcon16Regular = forwardRef('FoodDrinkCupStrawIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.405.25a1.5 1.5 0 0 0-1.486 1.3L7.588 4H4.555a1.25 1.25 0 0 0-1.243 1.38l.848 8.053A1.75 1.75 0 0 0 5.9 15h4.2a1.75 1.75 0 0 0 1.74-1.567l.848-8.052A1.25 1.25 0 0 0 11.445 4H9.1l.304-2.25h2.845a.75.75 0 0 0 0-1.5H9.405ZM5.652 13.276 4.833 5.5h6.334l-.819 7.776a.25.25 0 0 1-.248.224H5.9a.25.25 0 0 1-.248-.224Z" })));
});
